import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import type { VolumeDto } from '../types';

const DIAS_DESABILITADOS_COUNT = 0;

/**
 * Calcula as datas uteis desabilitadas a partir de hoje,
 * excluindo sabados e domingos, ate atingir o limite configurado.
 * @returns {dayjs.Dayjs[]}
 */
export const calcularDatasDesabilitadas = (): Dayjs[] => {
    let count = 0;
    const datasDesabilitadas = [];
    let atual = dayjs().startOf('day');

    while (count < DIAS_DESABILITADOS_COUNT) {
        atual = atual.add(1, 'day');
        const diaSemana = atual.day();
        const ehFimDeSemana = diaSemana === 0 || diaSemana === 6;
        if (!ehFimDeSemana) {
            datasDesabilitadas.push(atual.clone());
            count++;
        }
    }

    return datasDesabilitadas;
};

/**
 * Retorna funcao de desabilitacao de datas para o Calendar do Ant Design.
 * @param {Array<{date: string, type: string}>} eventsData
 * @param {dayjs.Dayjs[]} datasDesabilitadas
 * @returns {(current: dayjs.Dayjs) => boolean}
 */
export const criarFuncaoDataDesabilitada = (
    eventsData: readonly Pick<VolumeDto, 'date' | 'type'>[],
    datasDesabilitadas: readonly Dayjs[],
) => (current: Dayjs): boolean => {
    const ehPassado = current.isBefore(dayjs(), 'day');
    const ehHoje = current.isSame(dayjs(), 'day');
    const ehFimDeSemana = current.day() === 0 || current.day() === 6;

    if (ehPassado || ehHoje || ehFimDeSemana) {
        return true;
    }

    const datasComErro = eventsData
        .filter(event => event.type === 'error')
        .map(event => dayjs(event.date));

    const bloqueadaPorErro = datasComErro.some(date => current.isSame(date, 'day'));
    const bloqueadaPorContagem = datasDesabilitadas.some(date => current.isSame(date, 'day'));

    return bloqueadaPorErro || bloqueadaPorContagem;
};
